module.exports = __webpack_public_path__ + "img/tilly.c40e8cf3.jpg";